import { formatAddress, formatDate, formatNameLastFirst } from '@strata/helper-functions';
import { FormTitleLabelValuePair, HeaderLabelValuePair } from '@strata/react-label-value-pairs';
import PropTypes from 'prop-types';

// eslint-disable-next-line complexity
export const PatientDetailsHeader = ({ patientDetails = undefined }) => {
    const enrollmentDates = `${formatDate(patientDetails?.eligibility?.coverage_start_date)} - ${
        patientDetails?.eligibility?.coverage_end_date
            ? formatDate(patientDetails.eligibility.coverage_end_date)
            : 'Present'
    }`;

    return (
        <>
            <FormTitleLabelValuePair
                label={formatNameLastFirst(
                    patientDetails?.eligibility?.patient_last_name,
                    patientDetails?.eligibility?.patient_first_name,
                )}
                value={formatAddress(
                    patientDetails?.eligibility?.member_city,
                    patientDetails?.eligibility?.member_state,
                    patientDetails?.eligibility?.member_zip,
                )}
            />
            <HeaderLabelValuePair label="DOB" value={formatDate(patientDetails?.memberDOB)} />
            <HeaderLabelValuePair label="Age" value={patientDetails?.eligibility?.member_age} />
            <HeaderLabelValuePair label="Health Plan" value={patientDetails?.healthPlan?.name} />
            <HeaderLabelValuePair label="Member ID" value={patientDetails?.cardholderId} />
            <HeaderLabelValuePair label="Enrollment Dates" value={enrollmentDates} />
            <HeaderLabelValuePair label="Benefit" value={patientDetails?.benefit?.name} />
            <HeaderLabelValuePair
                label="Secondary Coverage"
                value={patientDetails?.eligibility?.secondary_coverage_flag ? 'Yes' : 'No'}
            />
        </>
    );
};

PatientDetailsHeader.propTypes = {
    patientDetails: PropTypes.shape({
        eligibility: PropTypes.shape({
            patient_first_name: PropTypes.string,
            patient_last_name: PropTypes.string,
            member_age: PropTypes.number,
            gender: PropTypes.string,
            is_eligible: PropTypes.bool,
            patient_address_line_1: PropTypes.string,
            patient_address_line_2: PropTypes.string,
            member_city: PropTypes.string,
            member_state: PropTypes.string,
            member_zip: PropTypes.string,
            coverage_start_date: PropTypes.string,
            coverage_end_date: PropTypes.string,
            secondary_coverage_flag: PropTypes.bool,
        }),
        memberDOB: PropTypes.string,
        healthPlan: PropTypes.shape({
            name: PropTypes.string,
        }),
        cardholderId: PropTypes.string,
        benefit: PropTypes.shape({
            name: PropTypes.string,
        }),
    }),
};
